<template>
  <div />
</template>

<script>
import { computed, defineComponent, useContext } from '@nuxtjs/composition-api';
import { useMeta } from '~/composables';

export default defineComponent({
  name: 'ProductMeta',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  head: {},
  setup(props) {
    const { app } = useContext();
    const { generatePageMeta } = useMeta();
    const { product: currentProduct } = props;

    const DEFAULT_TITLE = 'Sogni Di Cristallo®';
    const metaTitle = computed(() => {
      let categoryPart = '';
      switch (currentProduct?.sdc_type) {
        case '6cfe8954-5763-4066-b684-62c3ca9cfb23': {
          // Lampadari
          categoryPart = app.i18n.t('Murano Glass Chandelier');
          break;
        }
        case 'a5185464-13ce-4da4-8289-a6f16377ba48': {
          // Lampade A Sospensione
          categoryPart = app.i18n.t('Murano Glass Pendant Light');
          break;
        }
        case '6c2c180f-4577-4d22-bd0b-a11ffffc6f4e': {
          // Lampade Da Parete
          categoryPart = app.i18n.t('Murano Glass Sconce');
          break;
        }
        case 'f89bf5ea-94d7-4d6a-9d70-b6479b658243': {
          // Lampade Da Tavolo
          categoryPart = app.i18n.t('Murano Glass Table Lamp');
          break;
        }
        case '2e21a8df-8c8f-41cb-9aa4-6ab038ada3cc': {
          // Lampade Da Terra
          categoryPart = app.i18n.t('Murano Glass Floor lamp');
          break;
        }
        case '457ebef7-aad0-4ad9-ba05-32d5819c3edc': {
          // Lanterne
          categoryPart = app.i18n.t('Murano Glass Lantern');
          break;
        }
        case 'b1e26479-f47c-4c79-903e-7ede88a9dbda': {
          // Plafoniere
          categoryPart = app.i18n.t('Murano Glass Ceiling Lamp');
          break;
        }
        case '6ba35739-2d9b-4ac1-9b4d-54fc08e4782f': {
          // Specchi Veneziani
          categoryPart = app.i18n.t('Venetian Murano Mirror');
          break;
        }
        case '5febc9a2-bb4e-4f34-8c52-2f3156a18a03': {
          // Illuminazione Esterni
          categoryPart = app.i18n.t('Murano Outdoor Glass Lamp');
          break;
        }
        default: {
          categoryPart = undefined;
        }
      }

      return [currentProduct?.name, categoryPart, DEFAULT_TITLE]
        .filter(Boolean)
        .join(' ');
    });

    generatePageMeta(
      metaTitle.value,
      currentProduct?.meta_description,
      currentProduct?.meta_keyword || currentProduct?.name
    );
    return {
      currentProduct,
    };
  },
});
</script>

<style lang="scss" scoped></style>
